$(document).ready(function(){
});

$(function(){
    $(document).on("click", ".category_keywords", function(){
		$(this).toggleClass("select");

		var keyword = $(this).data('keyword');
		var current_keywords = $("input[name='keywords']").val()
		
		if(current_keywords.length === 0 ){
			current_keywords = [];
		}else{
			current_keywords = current_keywords.split(",");
		}

		if($(this).hasClass("select")){
			current_keywords.push(keyword);
			appendSelectedCategory(keyword);
		}else{
			current_keywords.splice(current_keywords.indexOf(keyword), 1)
			removeSelectedCategory(keyword)
		}

		$("input[name='keywords']").val(current_keywords.join(","));

		return false;
	});

    $(document).on("click", ".clearSelectedKeyword", function(){
		var keyword = $(this).parent("a").data("selected-keyword");
		removeSelectedCategory(keyword);

		removeKeyword(keyword);

		return false;
	});

    $(document).on("click", "#filterBtn", function(){
		getItems();
		return false;
	});

    $(".filterCategoryItem").click(function(){
		var category_code = $(this).attr('data-category-code');
		var desc = $(this).children("span").html();
		$("#filterCategoryTitle").html(desc+":");
		$("input[name='filterCategory']").val(category_code);
		$(".filterCategoryItem.selected").removeClass('selected');
		$(this).addClass('selected');
		$("input[name='page']").val(1);
		// getItems();
	});

	$(".filterGemItem").click(function(){
		var gem_code = $(this).attr('data-gem-code');
		var desc = $(this).children("span").html();
		$("#filterGemTitle").html(desc+":");
		$("input[name='filterGem']").val(gem_code);
		$(".filterGemItem.selected").removeClass('selected');
		$(this).addClass('selected');
		$("input[name='page']").val(1);
		// getItems();
	});

	$(".filterBaseMetalItem").click(function(){
		var basemetal_code = $(this).attr('data-basemetal-code');
		var desc = $(this).children("span").html();
		$("#filterBaseMetalTitle").html(desc+":");
		$("input[name='filterBaseMetal']").val(basemetal_code);
		$(".filterBaseMetalItem.selected").removeClass('selected');
		$(this).addClass('selected');
		$("input[name='page']").val(1);
		// getItems();
	});

	$(".filterTargetItem").click(function(){
		var target_code = $(this).attr('data-filter-target');
		var desc = $(this).children("span").html();
		$("#filterTargetTitle").html(desc+":");
		$("input[name='filterTarget']").val(target_code);
		$(".filterTargetItem.selected").removeClass('selected');
		$(this).addClass('selected');
		$("input[name='page']").val(1);
		// getItems();
	});

	$(".filterSortOrderItem").click(function(){
		var sort_order = $(this).attr('data-filter-sort-order');
		var desc = $(this).children("span").html();
		$("#filterSortOrderTitle").html(desc+":");
		$("input[name='filterSortOrder']").val(sort_order);
		$(".filterSortOrderItem.selected").removeClass('selected');
		$(this).addClass('selected');
		$("input[name='page']").val(1);
		// getItems();
	});

	$(".filterSortPriceItem").click(function(){
		var sort_price = $(this).attr('data-filter-sort-price');
		var desc = $(this).children("span").html();
		$("#filterSortPriceTitle").html(desc+":");
		$("input[name='filterSortPrice']").val(sort_price);
		$(".filterSortPriceItem.selected").removeClass('selected');
		$(this).addClass('selected');
		$("input[name='page']").val(1);
		// getItems();
	});

	$(".filterLimitItem").click(function(){
		var limit = $(this).attr('data-filter-limit');
        console.log(limit);
		$("input[name='filterLimit']").val(limit);
        $("#filterLimitTitle").html(limit+"件:");
		$(".filterLimitItem.selected").removeClass('selected');
		$(this).addClass('selected');
		$("input[name='page']").val(1);
		// getItems();
	});

    // $("input[name='filterKeyword']").change(function(){
	// 	getItems();
	// });

	$("input[name='filterPriceClear']").click(function(){
		$("input[name='filterPriceFrom']").val('');
		$("input[name='filterPriceTo']").val('');
		// getItems();
	});

	// $("input[name='filterPriceOk']").click(function(){
	// 	getItems();
	// });


	$(document).on("click", ".pagination li a", function(){
		var page = $(this).attr('href');
		$("input[name='page']").val(page);
		getItems();
		return false;
	});

	$(document).on("change", "select[name='spFilterCategory']", function(){
		$("input[name='filterCategory']").val($(this).val());
		$("input[name='page']").val(1);
		// getItems();
	});

	$(document).on("change", "select[name='spFilterGem']", function(){
		$("input[name='filterGem']").val($(this).val());
		$("input[name='page']").val(1);
		// getItems();
	});

	$(document).on("change", "select[name='spFilterBaseMetal']", function(){
		$("input[name='filterBaseMetal']").val($(this).val());
		$("input[name='page']").val(1);
		// getItems();
	});

	$(document).on("change", "select[name='spFilterTarget']", function(){
		$("input[name='filterTarget']").val($(this).val());
		$("input[name='page']").val(1);
		// getItems();
	});

	$(document).on("change", "select[name='spFilterSortOrder']", function(){
		$("input[name='filterSortOrder']").val($(this).val());
		$("input[name='page']").val(1);
		// getItems();
	});

	$(document).on("change", "select[name='spFilterSortPrice']", function(){
		$("input[name='filterSortPrice']").val($(this).val());
		$("input[name='page']").val(1);
		// getItems();
	});

	$(document).on("change", "select[name='spFilterLimit']", function(){
		$("input[name='filterLimit']").val($(this).val());
		$("input[name='page']").val(1);
		// getItems();
	});

	$(document).on("click", "input[name='filterKeywordClear']", function(){
		$("input[name='filterKeyword']").val('');
		getItems();
	});


	$(document).on("click", ".addPicklist", function(){
		addPicklist(this);
	});

	$(document).on("click", ".removePicklist", function(){
		removePicklist(this);
	});

	$(document).on("click", ".addFavorite", function(){
		addFavorite(this);
	});

	$(document).on("click", ".removeFavorite", function(){
		removeFavorite(this);
	});
});

window.appendSelectedCategory = function(keyword){
	var desc = $(document.querySelector("[data-keyword='"+keyword+"']")).html();

	var e = "<li>";
	e += "<a href='#' data-selected-keyword='"+keyword+"' class='btn fs-12'>"+desc+"<span class='fs-20 clearSelectedKeyword'>×</span></a>";
	e += "</li>";

	$(".selectCategoryList").append(e);
}

window.removeSelectedCategory = function(keyword){
	var e = $(document.querySelector("[data-selected-keyword='"+keyword+"']"));
	$(e).parent("li").remove();

	$(document.querySelector("[data-keyword='"+keyword+"']")).removeClass("select");
}

window.removeKeyword = function(keyword){
	var current_keywords = $("input[name='keywords']").val();
	current_keywords = current_keywords.split(",");
	current_keywords.splice(current_keywords.indexOf(keyword), 1)

	$("input[name='keywords']").val(current_keywords.join(","));
}

window.addPicklist = function(e){
	var itemId = $(e).attr('data-item-id');
	$.ajax({
		type: "POST",
		data: {
			itemId: itemId,
		},
		url: '/jewelry/picklist/add',
		beforeSend: function(){
		},
		success: function(response){
			if(response.status){
				$(e).replaceWith("<span class='more fs-14 removePicklist' id='"+itemId+"' data-item-id='"+itemId+"'>借りたいものリスト登録済み</span>");
			}else{
			}
		},
		error: function(XMLHttpRequest, textStatus, errorThrown){
			console.log("An error occured. : " + textStatus + " : " + errorThrown);
		}
	});
}

window.removePicklist = function(e){
	var itemId = $(e).attr('data-item-id');
	$.ajax({
		type: "POST",
		data: {
			itemId: itemId,
		},
		url: '/jewelry/picklist/remove',
		beforeSend: function(){
		},
		success: function(response){
			if(response.status){
				$(e).replaceWith("<span class='more fs-14 addPicklist' id='"+itemId+"' data-item-id='"+itemId+"'>借りたいものリスト追加</span>");
			}else{
			}
		},
		error: function(XMLHttpRequest, textStatus, errorThrown){
			console.log("An error occured. : " + textStatus + " : " + errorThrown);
		}
	});
}

window.addFavorite = function(e){
	var itemId = $(e).attr('data-item-id');
	$.ajax({
		type: "POST",
		data: {
			itemId: itemId,
		},
		url: '/jewelry/favorite/add',
		beforeSend: function(){
		},
		success: function(response){
			if(response.status){
				$(e).replaceWith("<span class='more fs-14 removeFavorite' id='"+itemId+"' data-item-id='"+itemId+"'>お気に入り登録済み</span>");
			}else{
			}
		},
		error: function(XMLHttpRequest, textStatus, errorThrown){
			console.log("An error occured. : " + textStatus + " : " + errorThrown);
		}
	});
}

window.removeFavorite = function(e){
	var itemId = $(e).attr('data-item-id');
	$.ajax({
		type: "POST",
		data: {
			itemId: itemId,
		},
		url: '/jewelry/favorite/remove',
		beforeSend: function(){
		},
		success: function(response){
			if(response.status){
				$(e).replaceWith("<span class='more fs-14 addFavorite' id='"+itemId+"' data-item-id='"+itemId+"'>お気に入り追加</span>");
			}else{
			}
		},
		error: function(XMLHttpRequest, textStatus, errorThrown){
			console.log("An error occured. : " + textStatus + " : " + errorThrown);
		}
	});
}

window.initSelectedCategory = function(){
    var keywords = $("input[name='keywords']").val();
    if(keywords==''){
        return false;
    }
    keywords = keywords.split(",");

    for(var i=0; i<keywords.length; i++){
        appendSelectedCategory(keywords[i]);

        var k = document.querySelector("[data-keyword='"+keywords[i]+"']");
        $(k).addClass("select");
    }
}

window.getItems = function(){
	var filterCategory = $("input[name='filterCategory']").val();
	var filterGem = $("input[name='filterGem']").val();
	var filterBaseMetal = $("input[name='filterBaseMetal']").val();
	var filterTarget = $("input[name='filterTarget']").val();
	var filterSortOrder = $("input[name='filterSortOrder']").val();
	var filterSortPrice = $("input[name='filterSortPrice']").val();
	var filterLimit = $("input[name='filterLimit']").val();
	var filterPriceFrom = $("input[name='filterPriceFrom']").val();
	var filterPriceTo = $("input[name='filterPriceTo']").val();
	var filterKeyword = $("input[name='filterKeyword']").val();
    var filterBrand = $("input[name='filterBrand']").val();
	var keywords = $("input[name='keywords']").val();
	var page = $("input[name='page']").val();

    var data = {
        filterCategory: filterCategory,
        filterGem: filterGem,
        filterBaseMetal: filterBaseMetal,
        filterTarget: filterTarget,
        filterSortOrder: filterSortOrder,
        filterSortPrice: filterSortPrice,
        filterPriceFrom: filterPriceFrom,
        filterPriceTo: filterPriceTo,
        filterLimit: filterLimit,
        filterKeyword: filterKeyword,
        keywords: keywords,
        page: page,
    }

    if(filterBrand!=undefined){
        data.filterBrand = filterBrand;
    }

	$.ajax({
		type: "POST",
        data: data,
		url: '/search/getItems',
		beforeSend: function(){
			$(".itemlist").html('');
			$('body, html').scrollTop(0);
		},
		success: function(response){
			if(response.status){
				$("#filteredItemsCount").html("件数　：　"+response.count+"件");
				$.each(response.items.data, function(i, v){
					var str = "<div class='item'>";
					str += "<a href='"+v.item_detail_url+"'><span class='thumbs'>";
					if(v.item_image_url){
						str += "<img src='"+v.item_image_url+"' alt=''>";
					}else{
						str += "<img src='' alt=''>";
					}
					str += "</span></a>";
					str += "<a href='"+v.item_detail_url+"'><span class='fs-14'>"+v.name+"</span></a>";
					str += "<a href='"+v.item_detail_url+"'><span class='fs-14'>¥"+v.retail_price+"</span></a>";
					str += "<a href='"+v.item_detail_url+"'><span class='more fs-14'>MORE</span></a><br>";

					if(response.isLogin==true){
						if(response.picklist==false){
							str += "<span class='more fs-14 addPicklist' id='"+v.id+"' data-item-id='"+v.id+"'>借りたいものリスト追加</span><br>";
						}else{
							if(response.picklist.indexOf(v.id) >= 0){
								str += "<span class='more fs-14 removePicklist' id='"+v.id+"' data-item-id='"+v.id+"'>借りたいものリスト登録済み</span><br>";
							}else{
								str += "<span class='more fs-14 addPicklist' id='"+v.id+"' data-item-id='"+v.id+"'>借りたいものリスト追加</span><br>";
							}
						}

						if(response.favorites==false){
							str += "<span class='more fs-14 addFavorite' id='"+v.id+"' data-item-id='"+v.id+"'>お気に入り追加</span>";
						}else{
							if(response.favorites.indexOf(v.id) >= 0){
								str += "<span class='more fs-14 removeFavorite' id='"+v.id+"' data-item-id='"+v.id+"'>お気に入り登録済み</span>";
							}else{
								str += "<span class='more fs-14 addFavorite' id='"+v.id+"' data-item-id='"+v.id+"'>お気に入り追加</span>";
							}
						}
					}

					str += "</div>";
					$(".itemlist").append(str);
				});

				var start = response.items.current_page - 2;
				if(start < 1){
					start = 1;
				}

				var end = response.items.current_page + 2;
				if(end > response.items.last_page){
					end = response.items.last_page;
				}

				var prev_page = response.items.current_page - 1;
				if(prev_page==0){
					var pager = "";
				}else{
					var pager = "<li class='pre'><a href='"+prev_page+"'><span class='fs-14'>«</span></a></li>";
				}

				for(var i = start; i <= end; i++){
					if(i==response.items.current_page){
						pager += "<li><a href='"+i+"' class='active'><span class='fs-14'>"+i+"</span></a></li>";
					}else{
						pager += "<li><a href='"+i+"'><span class='fs-14'>"+i+"</span></a></li>";
					}
				}
				var next_page = response.items.current_page + 1;
				if(next_page<=response.items.last_page){
					pager += "<li class='next'><a href='"+response.items.next_page_url.split("=")[1]+"'><span class='fs-14'>»</span></a></li>";
				}

				$(".pagination").html(pager);

			}else{
				$(".itemlist").html("<p class='fs-18'>"+response.message+"</p>");
				$(".pagination").html('');
                $("#filteredItemsCount").html("件数　：　0件");
			}
		},
		error: function(XMLHttpRequest, textStatus, errorThrown){
			console.log("An error occured. : " + textStatus + " : " + errorThrown);
		}
	});

}